import {Locales} from '@netx/core-next/locales/utils/Locales';
import {UserIntegrationField} from './schema';

export const UserIntegrationMessage = Locales((i18n) => ({
	NO_RECORDS: i18n('i18n.noRecords'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),
	ERROR: i18n('i18n.error'),
	DELETED: i18n('i18n.revokeAccessSuccess'),
	SAVE_A_COPY: i18n('i18n.integrationCreatedMessage'),
	UPDATED: i18n('i18n.apiTokenUpdated'),
	AUTHORIZE_SUCCESS: i18n('i18n.authorizeIntegrationSuccess'),
	CONFIRM_DELETE: (name: string) =>
		i18n('i18n.revokeAPITokenDescription', {name}),
	ADDED: (integration: string) =>
		i18n('i18n.userIntegrationSuccessfullyCreated', {label: integration}),
}));

export const UserIntegrationColumnLabels = Locales((i18n) => ({
	[UserIntegrationField.name]: i18n('i18n.name'),
	[UserIntegrationField.type]: i18n('i18n.type'),
	[UserIntegrationField.creationDate]: i18n('i18n.accessGranted'),
	[UserIntegrationField.modDate]: i18n('i18n.lastAccess'),
	[UserIntegrationField.actionSummaries]: i18n('i18n.permissions'),
}));

export const UserIntegrationsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.integrations'),
}));

export const UserIntegrationActionLabel = Locales((i18n) => ({
	EDIT: i18n('i18n.edit'),
	DELETE: i18n('i18n.revokeAccess'),
	ADD: i18n('i18n.addAPIToken'),
	SAVE: i18n('i18n.save'),
	SAVED_TOKEN: i18n('i18n.savedTokenConfirm'),
	DENY: i18n('i18n.deny'),
	ALLOW: i18n('i18n.btnAllow'),
	REVOKE: i18n('i18n.revoke'),
}));

export const UserIntegrationsSubTitle = Locales((i18n) => ({
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
	CHOOSE_INTEGRATION_NAME: i18n('i18n.chooseIntegrationName'),
	AUTHORIZE_APPLICATION: (name: string) =>
		i18n('i18n.appIsRequestingAccessTo', {
			name,
		}),
}));

export const UserIntegrationsTitle = Locales((i18n) => ({
	TITLE: i18n('i18n.integrations'),
	EDIT: i18n('i18n.editAPIToken'),
	ADD: i18n('i18n.addAPIToken'),
	COPY: i18n('i18n.copyIntegration'),
	CONFIRM_DELETE: i18n('i18n.revokeAccessTitle'),
	AUTHORIZE_APPLICATION: i18n('i18n.authorizeApplication'),
}));

export const UserIntegrationManagerFormLabel = Locales((i18n) => ({
	[UserIntegrationField.name]: i18n('i18n.name'),
}));
